"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentCardType = exports.PaymentSource = exports.PaymentType = exports.PaymentTransactionType = exports.PaymentTokenType = void 0;
var PaymentTokenType;
(function (PaymentTokenType) {
    PaymentTokenType["STT"] = "stt";
})(PaymentTokenType = exports.PaymentTokenType || (exports.PaymentTokenType = {}));
var PaymentTransactionType;
(function (PaymentTransactionType) {
    PaymentTransactionType["PAYMENT"] = "payment";
})(PaymentTransactionType = exports.PaymentTransactionType || (exports.PaymentTransactionType = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["CUSTOM_CHECKOUT"] = "customcheckout";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var PaymentSource;
(function (PaymentSource) {
    PaymentSource["MY_ACCOUNT"] = "MY_ACCOUNT";
    PaymentSource["WEBSITE"] = "WEBSITE";
})(PaymentSource = exports.PaymentSource || (exports.PaymentSource = {}));
var PaymentCardType;
(function (PaymentCardType) {
    PaymentCardType["VISA"] = "visa";
    PaymentCardType["MASTERCARD"] = "mastercard";
    PaymentCardType["AMEX"] = "amex";
    PaymentCardType["EMPTY"] = "";
})(PaymentCardType = exports.PaymentCardType || (exports.PaymentCardType = {}));
//# sourceMappingURL=PaymentEnum.js.map